<template>
  <div class="page-content user-profile">

    <!-- USER PROFILE HEADLINE -->
    <div class="page-title">
      <span>{{ $lang.messages.userProfile.toUpperCase() }}</span>
    </div>

    <!-- PERSONAL INFO -->
    <div class="profile-content-row">
      <div class="row profile-header">
        <span class="title">{{ $lang.messages.personalInformation }}</span>
        <button
          class="generic-btn no-ico enabled"
          type="button"
          @click="showPersonalInfoModal"
        >
          {{ $lang.messages.editPersonalInfo }}
        </button>
        <button
          class="generic-btn no-ico enabled"
          type="button"
          @click="showChangePasswordModal"
        >
          {{ $lang.messages.changePassword }}
        </button>

        <span class="actions-ico" @click="togglePersonalInfoActions()">
          <img src="@/assets/images/payments/actions_ico.png" />
        </span>

        <div class="action-menu" :class="[ personalInfoActions ? 'select-menu-collapsed' : 'select-menu-not-collapsed' ]">
          <div>
            <button class="item btn-item" @click="showPersonalInfoModal">
              {{ $lang.messages.editPersonalInfo }}
            </button>
            <button class="item btn-item" @click="showChangePasswordModal">
              {{ $lang.messages.changePassword }}
            </button>
          </div>
        </div>

        <!-- Change Password modal -->
        <change-password-modal
            class="enabled"
            ref="changePasswordComponent">
        </change-password-modal>

        <!-- Edit Personal Info modal -->
        <personal-info-modal
            class="enabled"
            :personalInfoData="personalInfoData"
            @loadUserProfile="loadUserProfile()"
            ref="personalInfoComponent">
        </personal-info-modal>
      </div>
      <hr>
      <div class="row profile-body">
        <div class="col">
          <p class="info-title">{{ $lang.messages.name }}</p>
          <p class="info-data">{{ personalInfoData.firstName }} {{personalInfoData.lastName }}</p>
          <p class="info-title">{{ $lang.messages.email }}</p>
          <p class="info-data">{{ personalInfoData.email }}</p>
        </div>
        <div class="col">
          <p class="info-title">{{ $lang.messages.dateOfBirth }}</p>
          <p class="info-data" v-if="fillDateBirth != null">{{ fillDateBirth }}</p>
          <p class="info-data" v-if="fillDateBirth == null">-</p>
          <p class="info-title">{{ $lang.messages.country }}</p>
          <p class="info-data">{{ personalInfoData.country }}</p>
        </div>
        <div class="col last">
          <p class="info-title">{{ $lang.messages.accountCreationDate }}</p>
          <p class="info-data">{{ dateFormat(personalInfoData.accountCreationDate) }}</p>
          <p class="info-title" v-show="personalInfoData.phoneNumber !== null">{{ $lang.messages.phoneNumber }}</p>
          <p class="info-data" v-show="personalInfoData.phoneNumber !== null">{{ personalInfoData.phoneNumber }}</p>
        </div>
      </div>
    </div>

      <!-- DELETE ACCOUNT -->
    <div class="profile-content-row">
      <div class="row profile-header">
        <span class="title">{{ $lang.messages.deleteAccount }}</span>
        <button
            class="generic-btn no-ico enabled delete-account-btn"
            type="button"
            @click="showDeleteAccountModal"
        >
          {{ $lang.messages.deleteAccount }}
        </button>

        <span class="actions-ico" @click="toggleDeleteAccountActions()">
          <img src="@/assets/images/payments/actions_ico.png" />
        </span>

        <div class="action-menu" :class="[ deleteAccountActions ? 'select-menu-collapsed' : 'select-menu-not-collapsed' ]">
          <div>
            <button class="item btn-item" @click="showDeleteAccountModal">
              {{ $lang.messages.deleteAccount }}
            </button>
          </div>
        </div>

        <!-- Delete Account modal -->
        <delete-account-modal
          ref="deleteAccountComponent">
        </delete-account-modal>
      </div>
      <hr>
      <div class="row">
        <div class="col">
          <p class="info-title uppercase-text warning-text">{{ $lang.messages.deleteAccountWarningTitle }}</p>
          <p class="info-data">{{ $lang.messages.deleteAccountWarningText }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import {GET_USER_PROFILE} from "@/store/action.types";
import {
  SET_HAS_COPARENT,
  SET_HAS_CHILDREN,
  SET_HAS_RECORD_KEEPING_COPARENTS
} from "@/store/mutation.types";
import FPTableUserProfile from "@/components/common/tables/FPTableUserProfile";
import Autocomplete from "@/components/common/Autocomplete";
import Datepicker from 'vuejs-datepicker';
import ChangePasswordModal from "@/components/appLayout/views/profile/ChangePasswordModal";
import PersonalInfoModal from "@/components/appLayout/views/profile/PersonalInfoModal";
import { dateFilter } from 'vue-date-fns';
import vClickOutside from 'v-click-outside';
import { dateFormat } from '@/mixins/dateFormat';
import DeleteAccountModal from "@/components/appLayout/views/profile/DeleteAccountModal";
import STATUS_CODES from "@/common/statusCodes";

export default {
  name: "userProfile",
  components: {
    FPTableUserProfile,
    Autocomplete,
    Datepicker,
    ChangePasswordModal,
    PersonalInfoModal,
    'delete-account-modal': DeleteAccountModal,
  },
  mixins: [
    dateFormat
  ],
  directives: {
    clickOutside: vClickOutside.directive
  },
  filters: {
    date: dateFilter
  },
  data() {
    return {
      personalInfoData: {},
      personalInfoActions: false,
      deleteAccountActions: false
    };
  },
  computed: {
    fillDateBirth() {
      return !this.personalInfoData.dateOfBirth ?
          this.personalInfoData.dateOfBirth : this.dateFormat(this.personalInfoData.dateOfBirth)
    },
  },
  mounted() {
    this.loadUserProfile();
  },
  methods: {
    ...mapActions({
      getUserProfileAction: GET_USER_PROFILE
    }),
    ...mapMutations({
      hasCoparentMutation: SET_HAS_COPARENT,
      hasChildrenMutation: SET_HAS_CHILDREN,
      hasRecordKeepingCoparentsMutation: SET_HAS_RECORD_KEEPING_COPARENTS
    }),
    loadUserProfile() {
      this.getUserProfileAction()
      .then(response => {
        this.personalInfoData = response.data.data;
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR')
          }
        }
      });
    },
    showChangePasswordModal() {
      this.$refs.changePasswordComponent.show()
    },
    showPersonalInfoModal() {
      this.$refs.personalInfoComponent.show()
    },
    togglePersonalInfoActions() {
      this.personalInfoActions = !this.personalInfoActions
    },
    showDeleteAccountModal() {
      this.$refs.deleteAccountComponent.show()
    },
    toggleDeleteAccountActions() {
      this.deleteAccountActions = !this.deleteAccountActions
    }
  }
};
</script>
